import script from "./RoutingAddressesEmptyNotDetected.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoutingAddressesEmptyNotDetected.vue?vue&type=script&setup=true&lang=ts"

import "./RoutingAddressesEmptyNotDetected.vue?vue&type=style&index=0&id=0ec3881a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ec3881a"]])

export default __exports__